import React, { useState , useRef, useEffect} from 'react';
import { Stepper, Step, StepLabel, Button, InputAdornment, Typography, Box, TextField, Grid , Tooltip, FormControlLabel ,Switch, Divider, Table, TableHead, TableBody, 
    TableCell, TableFooter, TableRow, useMediaQuery, useTheme} from '@material-ui/core';
import InputMask from 'react-input-mask';
import './FichaCadastro.css'
import TextFieldUF from '../../components/base/TextFieldUF';
import TextFieldEmail from '../../components/base/TextFieldEmail';
import TextFieldCNPJ from '../../components/base/TextFieldCNPJ';
import TextFieldCPF from '../../components/TextFieldCPF';
import TextFieldCEP from '../../components/TextFieldCEP';
import DeleteIcon from '@material-ui/icons/Delete'
import Swal from 'sweetalert2';
import IconError from '@material-ui/icons/Warning'
import { SnackbarProvider, useSnackbar } from 'notistack';
import TextFieldTelefone from '../../components/base/TextFieldTelefone';
import FichaResponsavelEmpresa from './FichaResponsavelEmpresa';
import FichaLocaisDeInstalacao from './FichaLocaisDeInstalacao';
import FileUpload from './FileUpload';

import ResumoFicha from "./ResumoFicha";



const steps = ['Informações Cadastrais', 'Representantes Legais', 'Informações de Faturamento', 'Locais de Instalação', 'Upload de Documentos', 'Confirmação'];

function StepperComponent(props) {

  const [activeStep, setActiveStep] = useState(0);
  const [incompleto, setIncompleto]= useState(false);
  const [razaoSocial, setRazaoSocial] = useState('');
  const [nomeFantasia, setNomeFantasia] = useState('');
  const [tipoEmpresa, setTipoEmpresa] = useState(props.tipoPessoa?.toLowerCase() === 'f' ? 'F' : 'J');
  const [cpfcnpj, setCpfcnpj] = useState('');
  const [rginsc, setRginsc] = useState('');
  const [ramoAtividade, setRamoAtividade] = useState('');
  const [logradouro, setLogradouro] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [bairro, setBairro] = useState('');
  const [cep, setCep] = useState('');
  const [cidade, setCidade] = useState('');
  const [estado, setEstado] = useState('');
  const [telefone, setTelefone] = useState('');
  const [celular, setCelular] = useState('');
  const [emailnfe, setEmailnfe] = useState('');
  const [nomeResponsavel, setNomeResponsavel] = useState('');
  const [emailResponsavel, setEmailResponsavel] = useState('');
  const [telefoneResponsavel, setTelefoneResponsavel] = useState('');
  const [cargoResponsavel, setCargoResponsavel] = useState('');
  const [nomeTestemunha, setNomeTestemunha] = useState('');
  const [emailTestemunha, setEmailTestemunha] = useState('');
  const [cpfTestemunha, setCpfTestemunha,] = useState('');
  const [rgTestemunha, setRgTestemunha] = useState('');
  const [telefoneTestemunha, setTelefoneTestemunha] = useState('');
  const [cargoTestemunha, setCargoTestemunha] = useState('');
  const [dataEmpresa, setDataEmpresa] = useState([])
  const [hintText, setHintText] =  useState('');
  const [usarEnderecoFaturamento, setUsarEnderecoFaturamento]= useState(true);
  const [usarEnderecoInstalacao, setUsarEnderecoInstalacao]= useState(true);
  const [logradouroFaturamento, setLogradouroFaturamento] = useState('');
  const [numeroFaturamento, setNumeroFaturamento] = useState('');
  const [complementoFaturamento, setComplementoFaturamento] = useState('');
  const [bairroFaturamento, setBairroFaturamento] = useState('');
  const [cepFaturamento, setCepFaturamento] = useState('');
  const [cidadeFaturamento, setCidadeFaturamento] = useState('');
  const [estadoFaturamento, setEstadoFaturamento] = useState('');
  const [telefoneFaturamento, setTelefoneFaturamento] = useState('');
  const [celularFaturamento, setCelularFaturamento] = useState('');
  const [emailnfeFaturamento, setEmailnfeFaturamento] = useState('');
  const [files, setFiles] = useState([]);
  const [data, setData]= useState([]);
  const [tipoPessoa, setTipoPessoa]= useState(props.tipoPessoa);
 

  const [locaisInstalacao, setLocaisInstalacao] = useState([])
  const [localPadrao, setLocalPadrao] = useState([])

  const theme = useTheme();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));


  const limparCamposPessoa = () =>{

        setCpfcnpj('')
        setRginsc('')
        setRazaoSocial('')
        setNomeFantasia('')
        setRamoAtividade('')
        setLogradouroFaturamento('');
        setNumeroFaturamento('');
        setComplementoFaturamento('');
        setBairroFaturamento('');
        setCepFaturamento('');
        setCidadeFaturamento('');
        setEstadoFaturamento('');
        setTelefoneFaturamento('');
        setCelularFaturamento('');
        setEmailnfeFaturamento('')


  }
  useEffect(()=>{
    if(tipoEmpresa.toUpperCase() === 'J'){
        if(dataEmpresa){
            setRazaoSocial(dataEmpresa.razao_social)
            setNomeFantasia(dataEmpresa.nome_fantasia)
            setLogradouro(dataEmpresa.logradouro);
            setNumero(dataEmpresa.numero);
            setComplemento(dataEmpresa.complemento);
            setBairro(dataEmpresa.bairro);
            setCep(dataEmpresa.cep);
            setCidade(dataEmpresa.municipio);
            setEstado(dataEmpresa.uf);
            setEmailnfe(dataEmpresa.email)
        }else{
            setRazaoSocial('')
            setNomeFantasia('')
            setLogradouro('');
            setNumero('');
            setComplemento('');
            setBairro('');
            setCep('');
            setCidade('');
            setEstado('');
            setEmailnfe('')
        }
    }
   console.log(dataEmpresa)
  }, [dataEmpresa])
  const resetEmpresaCNPJ = () =>{
            setRazaoSocial('')
            setNomeFantasia('')
            setLogradouro('');
            setNumero('');
            setComplemento('');
            setBairro('');
            setCep('');
            setCidade('');
            setEstado('');
            setEmailnfe('')
  }

  React.useEffect(()=>{
    limparCamposPessoa()
    setLocaisInstalacao([])
    setData([])
    setHintText('');
  }, [tipoEmpresa])



  React.useEffect(()=>{
    console.log(locaisInstalacao)
    
  }, [locaisInstalacao])

  React.useEffect(()=>{
        console.log('teste ')
        console.log(props)
    
  }, [])


 

  React.useEffect(() => {
    setHintText('');
    if(activeStep == 1){
        setHintText('Cadastre o(s) responsável(eis) pela empresa através do botão NOVO REPRESENTANTE')
    }
    
    if (activeStep === 2) {
        Swal.fire({
            title : 'Corporate Web', 
            text : 'Deseja usar o endereço de cadastro como endereço de FATURAMENTO ?', 
            icon : 'question', 
            showConfirmButton : true, 
            confirmButtonText : 'SIM', 
            showCancelButton : true, 
            cancelButtonText : 'Não'
        }).then(resposta=>{
            if(resposta.isConfirmed){
                setLogradouroFaturamento(logradouro);
                setNumeroFaturamento(numero);
                setComplementoFaturamento(complemento);
                setBairroFaturamento(bairro);
                setCepFaturamento(cep);
                setCidadeFaturamento(cidade);
                setEstadoFaturamento(estado);
                setTelefoneFaturamento(telefone);
                setCelularFaturamento(celular);
                setEmailnfeFaturamento(emailnfe)
            }else{
                setLogradouroFaturamento('');
                setNumeroFaturamento('');
                setComplementoFaturamento('');
                setBairroFaturamento('');
                setCepFaturamento('');
                setCidadeFaturamento('');
                setEstadoFaturamento('');
                setTelefoneFaturamento('');
                setCelularFaturamento('');
                setEmailnfeFaturamento('')
            }
          //  handleNext();

        });
    }
   
    if (activeStep === 3) {
        
        
        Swal.fire({
            title : 'Corporate Web', 
            text : 'Deseja usar o endereço principal (cadastro) como endereço de instalação', 
            icon : 'question', 
            showConfirmButton : true, 
            confirmButtonText : 'SIM', 
            showCancelButton : true, 
            cancelButtonText : 'Não'
        }).then(resposta=>{

            if(resposta.isConfirmed){

                const newId = locaisInstalacao.length > 0 ? Math.max(...locaisInstalacao.map((row) => row.id)) + 1 : 1;
                setLocaisInstalacao([...locaisInstalacao, { id: newId, 
                    nomeLocal: "LOCAL PADRÃO",
                      default: true,
                      logradouro,
                      numero,
                      complemento,
                      bairro,
                      cep,
                      cidade,
                      estado,
                      telefone,
                      celular,
                      contato: nomeResponsavel,
                      telefoneResponsavel,
                      setor: cargoResponsavel,
                      emailResponsavel }]);
                
              // handleNext();
            }
        })
    }
  }, [activeStep]);
  
  


 const showAlertMessage = (title, text) =>{
    Swal.fire({
        title :title, 
        text : text, 
        icon : 'warning', 
        showCancelButton : false, 
        showConfirmButton : false, 
        timer : 1500
    })
 }


 useEffect(()=>{
    setIncompleto((prevState)=>{
        return false
    })
 }, [cpfcnpj, rginsc, razaoSocial, nomeFantasia, cep, logradouro, numero, bairro, cidade, estado, celular, emailnfe, 
    nomeResponsavel, emailResponsavel, telefoneResponsavel, cargoResponsavel
  ])



  const handleNext = () => {
    setIncompleto(false)
    setActiveStep((prevActiveStep) => {
        if(prevActiveStep === 0 && tipoEmpresa.toUpperCase()  === 'J'){
            if(cpfcnpj === ''){
                showAlertMessage('Atenção', 'O CNP não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(rginsc === ''){
                showAlertMessage('Atenção', 'A Inscrição Estadual não foi informada, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(razaoSocial === ''){
                showAlertMessage('Atenção', 'A Razão social da empresa não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(nomeFantasia === ''){
                showAlertMessage('Atenção', 'O Nome Fantasia da empresa não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(cep === ''){
                showAlertMessage('Atenção', 'O CEP não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(logradouro === ''){
                showAlertMessage('Atenção', 'O Endereço (Logradouro) não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(numero === ''){
                showAlertMessage('Atenção', 'O Numero (endereço) não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(bairro === ''){
                showAlertMessage('Atenção', 'O Bairro não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(cidade === ''){
                showAlertMessage('Atenção', 'A Cidade não foi informada, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(estado === ''){
                showAlertMessage('Atenção', 'O Estado (UF) não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(celular === ''){
                showAlertMessage('Atenção', 'O número de celular não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(emailnfe === ''){
                showAlertMessage('Atenção', 'O Email para recebimento de NFe/NFSe não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(nomeResponsavel === ''){
                showAlertMessage('Atenção', 'O nome da pessoa de contato da empresa não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(emailResponsavel === ''){
                showAlertMessage('Atenção', 'O Email da pessoa de contato não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(telefoneResponsavel === ''){
                showAlertMessage('Atenção', 'O Telefone da pessoa de contato não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(cargoResponsavel === ''){
                showAlertMessage('Atenção', 'O Cargo/setor do responsável não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(nomeTestemunha === ''){
                showAlertMessage('Atenção', 'O nome da Testemunha não foi informado !, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(emailTestemunha === ''){
                showAlertMessage('Atenção', 'O email da Testemunha não foi informado !, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(cpfTestemunha === ''){
                showAlertMessage('Atenção', 'O CPF da Testemunha não foi informado !, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

           


            
        }else{
            if(cpfcnpj === ''){
                showAlertMessage('Atenção', 'O CPF não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(rginsc === ''){
                showAlertMessage('Atenção', 'O RG não foi informada, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(razaoSocial === ''){
                showAlertMessage('Atenção', 'A Nome Completo da empresa não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(cep === ''){
                showAlertMessage('Atenção', 'O CEP não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(logradouro === ''){
                showAlertMessage('Atenção', 'O Endereço (Logradouro) não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(numero === ''){
                showAlertMessage('Atenção', 'O Numero (endereço) não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(bairro === ''){
                showAlertMessage('Atenção', 'O Bairro não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(cidade === ''){
                showAlertMessage('Atenção', 'A Cidade não foi informada, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(estado === ''){
                showAlertMessage('Atenção', 'O Estado (UF) não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(celular === ''){
                showAlertMessage('Atenção', 'O número de celular não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(emailnfe === ''){
                showAlertMessage('Atenção', 'O Email para recebimento de NFe/NFSe não foi informado, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(nomeTestemunha === ''){
                showAlertMessage('Atenção', 'O nome da Testemunha não foi informado !, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(emailTestemunha === ''){
                showAlertMessage('Atenção', 'O email da Testemunha não foi informado !, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }

            if(cpfTestemunha === ''){
                showAlertMessage('Atenção', 'O CPF da Testemunha não foi informado !, verifique o preenchimento dos campos obrigatórios.');
                setIncompleto(true)
               return prevActiveStep; 
            }
        }
        if (tipoEmpresa.toUpperCase()  !== 'J' && prevActiveStep === 0) {

           

            return prevActiveStep + 2;  // Avança dois passos se tipoEmpresa não for 'J' e o passo atual for 0
        } else {
            
            return prevActiveStep + 1;  // Caso contrário, avança um passo
        }
    });
};


  const handleBack = () => {
    setActiveStep((prevActiveStep) => {
        if (tipoEmpresa.toUpperCase()  !== 'J' && prevActiveStep === 2) {
            return prevActiveStep - 2;  // Avança dois passos se tipoEmpresa não for 'J' e o passo atual for 0
        } else {
            return prevActiveStep - 1;  // Caso contrário, avança um passo
        }
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
  };



  return (
     
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep}  color='secondary' alternativeLabel={!isSmallScreen} orientation={isSmallScreen ? 'vertical' : 'horizontal'}>
        {steps.map((label, index) => (
          <Step key={label} disabled={(index === 1  && tipoEmpresa != 'J')} color='secondary'>
            <StepLabel noWrap={true} >{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <Box sx={{ mt: 2 }}>
     
        {activeStep === steps.length ? (
          <Box>
            <Typography variant="h6">Todos os passos foram concluídos</Typography>
            <Button onClick={handleReset}>Reiniciar</Button>
          </Box>
        ) : (
          <Box>
            {activeStep === 0 && (
              <Box style={{padding : '5%', paddingBottom : '50px', paddingTop : '10px', }}>
                <Typography variant="h6"># {steps[activeStep]}</Typography>
                <Grid container spacing={1} style={{marginTop : '10px'}}>
                    <Grid item xs ={12} lg={2}>
                        <TextField
                            variant='outlined'
                            label = 'Pessoa Física/Juridica'
                            select
                            required
                            disabled
                            hintText="Type" 
                            fullWidth
                            size='large'
                            SelectProps={{native :true}}
                            value={tipoEmpresa}
                            
                            onChange={(e)=>setTipoEmpresa(e.target.value.toUpperCase())}
                            InputLabelProps={ {shrink :true}}
                            >
                                <option value='F'>Física</option>
                                <option value='J'>Jurídica</option>
                            </TextField>
                    </Grid>
                </Grid>

                <Grid container spacing={1} style={{marginTop : '15px'}}>
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                    {tipoEmpresa == 'J' ?  <Tooltip title="Informe um CNPJ Válido e pressione ENTER para pesquisar" arrow><div><TextFieldCNPJ
                            variant='outlined'
                            label = {'CNPJ'}
                            className={'formError'}
                            fullWidth
                            hintText="Type" 
                            required={true}
                            size='large'
                            setError = {()=>setIncompleto(true)}
                            InputLabelProps={ {shrink :true}}
                            InputProps={{                               
                                inputComponent: InputMask,
                                inputProps: {
                                  mask: '99.999.999/9999-99', // Mascara para CNPJ
                                  maskChar: ' ' // Caracter usado para preencher os espaços vazios
                                }
                              }}
                              setDataEmpresa ={setDataEmpresa}
                              resetEmpresaCNPJ= {resetEmpresaCNPJ}
                            placeholder={!cpfcnpj ? 'Informe o CNPJ da empresa e pressione ENTER para pesquisar' : null}                   
                            value={cpfcnpj}
                            onChange={(e)=>setCpfcnpj(e.target.value.toUpperCase())}
                    
                           /> </div></Tooltip>: <Tooltip title="Informe um CPF Válido e pressione ENTER para pesquisar" arrow><div><TextFieldCPF
                           variant='outlined'
                           error = {incompleto && tipoEmpresa =='F' && cpfcnpj === ''} 
                           hintText="Type" 
                           size='large'
                           label = {'CPF *'}
                           className = 'input-required'
                           fullWidth
                           InputLabelProps={ {shrink :true}}   
                           InputProps={{
                            
                            inputComponent: InputMask,
                            inputProps: {
                              mask: '999.999.999-99', // Mascara para CNPJ
                              maskChar: ' ' // Caracter usado para preencher os espaços vazios
                            }
                          }}
                          
                          placeholder={!cpfcnpj ? 'Informe o seu CPF' : null}
                           value={cpfcnpj}
                           onChange={(e)=>setCpfcnpj(e.target.value.toUpperCase())}                   
                          /></div></Tooltip>
                            }
                    </Grid>

                    <Grid item xs={12} sm={6} md={2} lg={2}>
                    {tipoEmpresa == 'J' ? <TextField
                            variant='outlined'
                            size='large'
                            label = {'Inscrição Estadual *'}
                            className = 'input-required'
                            fullWidth
                            error={incompleto && rginsc === ''}
                            InputLabelProps={ {shrink :true}}
                            placeholder={!rginsc ? 'Informe a Inscrição Estadual' : null}
                            value={rginsc}
                            onChange={(e)=>setRginsc(e.target.value.toUpperCase())}
                      
                           /> : <TextField
                           variant='outlined'
                           label = {'RG *'}
                           className = 'input-required'
                           size='large'
                           fullWidth
                           InputLabelProps={ {shrink :true}}    
                           placeholder={!rginsc ? 'Informe o RG' : null}
                            value={rginsc}
                            onChange={(e)=>setRginsc(e.target.value.toUpperCase())}                    
                          />
                            }
                    </Grid>


                    <Grid item xs={12} sm={6} md={4} lg={4} >
                    <TextField
                           variant='outlined'
                           size='large'
                           label = {tipoEmpresa == 'J' ? 'Razão Social *' : 'Nome Completo *'}
                           fullWidth
                           placeholder={tipoEmpresa == 'J' ? 'Razão Social *' : 'Nome Completo *'}
                           className = 'input-required'
                           value={razaoSocial}
                           onChange={(e)=>setRazaoSocial(e.target.value.toUpperCase())} 
                           InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                    <TextField
                           variant='outlined'
                           size='large'
                           label = {tipoEmpresa == 'J' ? 'Nome Fantasia *' : 'Apelido'}
                           fullWidth
                           placeholder = {tipoEmpresa == 'J' ? 'Nome Fantasia *' : 'Apelido'}
                           value={nomeFantasia}
                           onChange={(e)=>setNomeFantasia(e.target.value.toUpperCase())} 
                           InputLabelProps={ {shrink :true}}  />
                    </Grid>
                </Grid>

                <Grid container spacing={1} style={{marginTop : '25px'}}>
                    <Grid item xs={12} sm={6} md={3} lg={3} >
                        <TextField
                            variant='outlined'
                            size='large'
                            label = {tipoEmpresa == 'J' ? 'Ramo de Atividade' : 'Profissão'}
                            fullWidth
                            placeholder={tipoEmpresa == 'J' ? 'Ramo de Atividade' : 'Profissão'}
                            value={ramoAtividade}
                            onChange={(e)=>setRamoAtividade(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid xs={12} sm={6} md={2} lg={2} style={{padding : '4px'}}>
                        <TextFieldCEP
                            variant='outlined'
                            size='large'
                            label = 'CEP *'
                            className = 'input-required'
                            fullWidth
                            placeholder='CEP' 
                            onFocus={()=>setHintText('Digite o CEP e pressione ENTER, se o CEP for válido o endereço será buscado na base de dados dos Correios.')}
                            onBlur ={()=>setHintText('')}
                            hintText="Type"     
                            setDataCep = {(data)=>{
                                if(data.logradouro){
                                    setLogradouro(data.logradouro)
                                    setComplemento(data.complemento)
                                    setBairro(data.bairro)
                                    setCidade(data.localidade)
                                    setEstado(data.uf)
                                }else{
                                    setLogradouro('')
                                    setComplemento('')
                                    setBairro('')
                                    setCidade('')
                                    setEstado('')
                                   // showMessage('warning', 'Endereço não localizado com base no CEP informad')
                                }
                                
                            }}                     
                            value={cep}
                            onChange={(e)=>setCep(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} >
                        <TextField
                            variant='outlined'
                            size='large'
                            label = 'Endereço (Rua, Avenida, Praça) *'
                            className = 'input-required'
                            fullWidth
                            placeholder ='Logradouro'
                            value={logradouro}
                            onChange={(e)=>setLogradouro(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid item xs={12} sm={6} md={1} lg={1} >
                        <TextField
                            variant='outlined'
                            size='large'
                            label = 'Número *'
                            fullWidth
                            placeholder ='Número'
                            className = 'input-required'
                            value={numero}
                            onChange={(e)=>setNumero(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>

                  
                </Grid>

                <Grid container spacing={1} style={{marginTop : '25px'}}>
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                        <TextField
                            variant='outlined'
                            size='large'
                            label = 'Complemento'
                            fullWidth
                            placeholder ='Complemento'
                            value={complemento}
                            onChange={(e)=>setComplemento(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                        <TextField
                            variant='outlined'
                            size='large'
                            label = 'Bairro *'
                            className = 'input-required'
                            fullWidth
                            placeholder ='Bairro'
                            value={bairro}
                            onChange={(e)=>setBairro(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid item xs={12} sm={6} md={5} lg={5}>
                        <TextField
                            variant='outlined'
                            size='large'
                            label = 'Cidade *'
                            className = 'input-required'
                            fullWidth
                            placeholder ='Cidade'
                            value={cidade}
                            onChange={(e)=>setCidade(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>

                    <Grid item xs={12} sm={6} md={1} lg={1}>
                        <TextFieldUF
                            variant='outlined'
                            size='large'
                            label = 'Estado *'
                            className = 'input-required'
                            fullWidth
                            placeholder ='Estado'
                            value={estado}
                            onChange={(e)=>setEstado(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                </Grid>


               <Grid container spacing={1} style={{marginTop : '25px'}}>
                    <Grid item xs={12} sm={6} md={2} lg={2}>
                        <TextFieldTelefone
                            variant='outlined'
                            size='large'
                            label = 'Telefone'
                            fullWidth
                            placeholder='Telefone'                            
                            value={telefone}
                            onChange={(e)=>setTelefone(e.target.value.toUpperCase())}                             
                            InputLabelProps={ {shrink :true}}  />
                           
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} lg={2}>
                        <TextFieldTelefone
                            variant='outlined'
                            size='large'
                            label = 'Celular *'
                            className = 'input-required'
                            fullWidth
                            placeholder='Celular'                                                 
                            value={celular}
                            onChange={(e)=>setCelular(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid item xs={12} sm={12} md={8} lg={8}>
                        <TextFieldEmail
                            variant='outlined'
                            size='large'
                            label = {tipoEmpresa =='J' ? 'Email NFe *' : 'Email *'}  
                            fullWidth
                            placeholder ={tipoEmpresa =='J' ? 'Email NFe' : 'Email'}   
                            className = 'input-required'
                            value={emailnfe}
                            onChange={(e)=>setEmailnfe(e.target.value.toLowerCase())} 

                            InputLabelProps={ {shrink :true}}  />
                    </Grid>

                </Grid>
                
               {

                /*
                <Grid container spacing={1} style={{marginTop : '10px'}}>
               
                    <Grid item xs = {12}>
        
                        
                        <FormControlLabel control={
                            <Switch checked={usarEnderecoFaturamento} onClick={()=>setUsarEnderecoFaturamento(!usarEnderecoFaturamento)}/>
                        } label="Usar este endereço como endereço de faturamento?" />
                    </Grid>

                </Grid>

                <Grid container spacing={1} style={{marginTop : '-10px'}}>
                    
                    <Grid item xs = {12}>
                    <FormControlLabel control={
                        <Switch checked={usarEnderecoInstalacao} onClick={()=>setUsarEnderecoInstalacao(!usarEnderecoInstalacao)}/>
                    } label="Usar este endereço como endereço de instalação?" />
                        
                    </Grid>

                </Grid>

                */

                }

                {tipoEmpresa =='J' ? <React.Fragment>
                    <Typography variant="h6" style={{marginTop : '25px'}}>Informações de Contato</Typography>
                <Grid container spacing={1} style={{marginTop : '15px'}}>
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                        <TextField
                            variant='outlined'
                            size='large'
                            label = 'Nome'
                            className = 'input-required'
                            fullWidth
                            placeholder='Nome do contato' 
                            focused                           
                            value={nomeResponsavel}
                            onChange={(e)=>setNomeResponsavel(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid item xs={12} sm={6} md={5} lg={5}>
                        <TextFieldEmail
                            variant='outlined'
                            size='large'
                            label = 'Email Contato '
                            className = 'input-required'
                            fullWidth
                            placeholder='Email do contato'                            
                            value={emailResponsavel}
                            onChange={(e)=>setEmailResponsavel(e.target.value.toLowerCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} lg={2}>
                        <TextFieldTelefone
                            variant='outlined'
                            size='large'
                            label = 'Telefone de contato ' 
                            className = 'input-required'
                            fullWidth
                            placeholder ='Telefone de contato' 
                            value={telefoneResponsavel}
                            onChange={(e)=>setTelefoneResponsavel(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>

                    <Grid item xs={12} sm={6} md={2} lg={2}>
                        <TextField
                            variant='outlined'
                            size='large'
                            label = 'Cargo/Setor ' 
                            fullWidth
                            placeholder ='Cargo/Setor' 
                            value={cargoResponsavel}
                            onChange={(e)=>setCargoResponsavel(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>

                </Grid></React.Fragment> : null }



                <React.Fragment>
                    <Typography variant="h6" style={{marginTop : '25px'}}>Informações da Testemunha</Typography>
                <Grid container spacing={1} style={{marginTop : '15px'}}>
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                        <TextField
                            variant='outlined'
                            size='large'
                            label = 'Nome da Testemunha*'
                            className = 'input-required'
                            fullWidth
                            placeholder='Nome da testemunha' 
                            focused                           
                            value={nomeTestemunha}
                            onChange={(e)=>setNomeTestemunha(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid item xs={12} sm={6} md={5} lg={5}>
                        <TextFieldEmail
                            variant='outlined'
                            size='large'
                            label = 'Email Testemunha (Assinatura www.autentique.com.br) *'
                            className = 'input-required'
                            fullWidth
                            placeholder='Email da testemunha'                            
                            value={emailTestemunha}
                            onChange={(e)=>setEmailTestemunha(e.target.value.toLowerCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} lg={2}>
                        <TextFieldCPF
                            variant='outlined'
                            size='large'
                            label = 'CPF Testemunha *'
                            className = 'input-required'
                            fullWidth
                            placeholder='CPF da testemunha'                            
                            value={cpfTestemunha}
                            onChange={(e)=>setCpfTestemunha(e.target.value.toLowerCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} lg={2}>
                        <TextFieldEmail
                            variant='outlined'
                            size='large'
                            label = 'RG da Testemunha'
                            className = 'input-required'
                            fullWidth
                            placeholder='RG da testemunha'                            
                            value={rgTestemunha}
                            onChange={(e)=>setRgTestemunha(e.target.value.toLowerCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    

                    
                </Grid></React.Fragment>


              </Box>
            )}
             {activeStep === 1 && (
            <Box  style={{padding : '5%'}}>
                <Typography variant="h6"># {steps[activeStep]}</Typography>
                <FichaResponsavelEmpresa data={data} setData={(value)=>setData(value)}/>
            </Box> 
             )}


            {activeStep === 2 && (
              <Box  style={{padding : '5%'}}>
                <Typography variant="h6"># {steps[activeStep]}</Typography>
                <Grid container spacing={1} style={{marginTop : '25px'}}>

                    <Grid item xs={12} sm={6} md={5} lg={5}>
                        <TextField
                            variant='outlined'
                            size='large'
                            label = 'Endereço (Rua, Avenida, Praça) *'
                            className = 'input-required'
                            fullWidth
                            placeholder ='Logradouro'
                            value={logradouroFaturamento}
                            onChange={(e)=>setLogradouroFaturamento(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid item xs={12} sm={6} md={1} lg={1}>
                        <TextField
                            variant='outlined'
                            size='large'
                            label = 'Número *'
                            fullWidth
                            placeholder ='Número'
                            className = 'input-required'
                            value={numeroFaturamento}
                            onChange={(e)=>setNumeroFaturamento(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <TextField
                            variant='outlined'
                            size='large'
                            label = 'Complemento'
                            fullWidth
                            placeholder ='Complemento'
                            value={complementoFaturamento}
                            onChange={(e)=>setComplementoFaturamento(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                </Grid>

                <Grid container spacing={1} style={{marginTop : '25px'}}>
                    <Grid item xs={12} sm={6} md={1} lg={1}>
                        <TextField
                            variant='outlined'
                            size='large'
                            label = 'CEP *'
                            className = 'input-required'
                            fullWidth
                            placeholder='CEP'
                            InputProps={{
                                inputComponent: InputMask,
                                inputProps: {
                                  mask: '99999-999', // Mascara para CNPJ
                                  maskChar: ' ' // Caracter usado para preencher os espaços vazios
                                }
                            }}
                            value={cepFaturamento}
                            onChange={(e)=>setCepFaturamento(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                        <TextField
                            variant='outlined'
                            size='large'
                            label = 'Bairro *'
                            className = 'input-required'
                            fullWidth
                            placeholder ='Bairro'
                            value={bairroFaturamento}
                            onChange={(e)=>setBairroFaturamento(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <TextField
                            variant='outlined'
                            size='large'
                            label = 'Cidade *'
                            className = 'input-required'
                            fullWidth
                            placeholder ='Cidade'
                            value={cidadeFaturamento}
                            onChange={(e)=>setCidadeFaturamento(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>

                    <Grid item xs={12} sm={6} md={1} lg={1}>
                        <TextFieldUF
                            variant='outlined'
                            size='large'
                            label = 'Estado *'
                            className = 'input-required'
                            fullWidth
                            placeholder ='Estado'
                            value={estadoFaturamento}
                            onChange={(e)=>setEstadoFaturamento(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                </Grid>


               <Grid container spacing={1} style={{marginTop : '25px'}}>
                    <Grid item xs={12} sm={6} md={2} lg={2}>
                        <TextField
                            variant='outlined'
                            size='large'
                            label = 'Telefone'
                            fullWidth
                            placeholder='Telefone'                            
                            value={telefoneFaturamento}
                            onChange={(e)=>setTelefoneFaturamento(e.target.value.toUpperCase())} 
                            InputProps={{
                                inputComponent: InputMask,
                                inputProps: {
                                  mask: '(99) 9999-9999', // Mascara para CNPJ
                                  maskChar: ' ' // Caracter usado para preencher os espaços vazios
                                }
                              }}
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} lg={2}>
                        <TextField
                            variant='outlined'
                            size='large'
                            label = 'Celular *'
                            className = 'input-required'
                            fullWidth
                            placeholder='Celular' 
                            InputProps={{
                                inputComponent: InputMask,
                                inputProps: {
                                  mask: '(99) 9 9999-9999', // Mascara para CNPJ
                                  maskChar: ' ' // Caracter usado para preencher os espaços vazios
                                }
                              }}                           
                            value={celularFaturamento}
                            onChange={(e)=>setCelularFaturamento(e.target.value.toUpperCase())} 
                            InputLabelProps={ {shrink :true}}  />
                    </Grid>
                    <Grid item xs={12} sm={12} md={8} lg={8}>
                        <TextFieldEmail
                            variant='outlined'
                            size='large'
                            label = {tipoEmpresa =='J' ? 'Email NFe' : 'Email'}  
                            fullWidth
                            placeholder ={tipoEmpresa =='J' ? 'Email NFe' : 'Email'}   
                            className = 'input-required'
                            value={emailnfeFaturamento}
                            onChange={(e)=>setEmailnfeFaturamento(e.target.value.toUpperCase())} 

                            InputLabelProps={ {shrink :true}}  />
                    </Grid>

                </Grid>
              </Box>
            )}

       


            {activeStep === 3 && (
              <Box  style={{padding : '5%'}}>
                <Typography variant="h6"># {steps[activeStep]}</Typography>
                
                <FichaLocaisDeInstalacao data ={locaisInstalacao} setData ={(value)=>setLocaisInstalacao(value)}/>


               
              </Box>
            )}

        {activeStep === 4 && (
              <Box  style={{padding : '5%', paddingTop : '25px'}}>
                <Typography variant="h6"># {steps[activeStep]}</Typography>
               
                <FileUpload
                    files = {files}
                    setFiles = {(data)=>setFiles(data)}
                    tipoEmpresa = {tipoEmpresa}
                />


               
              </Box>
            )}

    {activeStep === 5 && (
              <ResumoFicha
               setShowBackdrop ={(op)=>props.setShowBackdrop(op)}
                ficha ={
                    {
                        razaoSocial : razaoSocial, 
                        nomeFantasia : nomeFantasia,
                        tipoEmpresa :tipoEmpresa, 
                        cpfcnpj,
                        rginsc, 
                        ramoAtividade,
                        logradouro, 
                        numero, 
                        complemento, 
                        bairro, 
                        cep, 
                        cidade, 
                        estado, 
                        telefone, 
                        celular, 
                        emailnfe, 
                        contatoEmpresa : {
                            nomeResponsavel,
                            emailResponsavel,
                            telefoneResponsavel, 
                            cargoResponsavel, 
                        },
                        testemunha :{
                            nomeTestemunha, 
                            emailTestemunha,
                            cpfTestemunha, 
                            rgTestemunha
                        },
                        representantes : data,                                                                       
                        locaisInstalacao : locaisInstalacao,                         
                        informacoesFaturamento : {
                            logradouroFaturamento, 
                            numeroFaturamento,
                            complementoFaturamento,
                            bairroFaturamento,
                            cepFaturamento, 
                            cidadeFaturamento, 
                            estadoFaturamento, 
                            telefoneFaturamento, 
                            celularFaturamento, 
                            emailnfeFaturamento
                        }, 
                        files : files, 

                    }
                }
              />
            )}




        <div style={{width : '100%', minHeight : '25px', paddingLeft : '5%'}}>
        <Typography variant='caption' >{hintText ? 'Dica :' : null } {hintText}</Typography>
        </div>
            <Divider />
          </Box>
        )}


        
       
         <Box sx={{ mt: 2 }} style={{textAlign : 'center', paddingBottom : '150px', marginTop : '10px'}}>              
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleBack}
                style={{height : '90px'}}
                disabled={activeStep === 0}
              >
                Passo Anterior
              </Button>

              {activeStep < 5 ? <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                sx={{ mr: 1 }}
                style={{marginLeft : '25px', height : '90px'}}
                disabled={activeStep === steps.length - 1}
              >
                Próximo Passo
              </Button> : null }
            </Box>
      </Box>
    </Box>

  );
}

export default StepperComponent;
